import React from "react";
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Resoures1 from '../../assets/images/resoures1.png'
import Resoures2 from '../../assets/images/resoures2.png'
import Resoures3 from '../../assets/images/resoures3.png'
import Arrow from '../../assets/images/down-arrow.svg'

function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <FontAwesomeIcon icon={faChevronRight} />
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
           <FontAwesomeIcon icon={faChevronLeft} />
        </div>
    );
}
function Resources() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        initialSlide: 0,
        centerMode: false,
        nextArrow: <SampleNextArrow className="icon next"/>,
        prevArrow: <SamplePrevArrow className="icon prev"/>,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 3,
                    infinite: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    arrows: false,
                }
            }

        ]
    };
    return (
        <section className="resources main-padding">
            <div className="container-fluid p-0">
                <div className="heading text-center">
                    <h2>Resource For Getting Started</h2>
                </div>
                <Slider className="border-slider" {...settings}>
                    <div className="item p-0">
                        <a href="#" >
                            <div className="image">
                                <img src={Resoures1} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">
                                <h5>Keeping yourself safe when buying NFTs on Toppy</h5>
                            </div>
                        </a>
                    </div>
                    <div className="item p-0">
                        <a href="#" >
                            <div className="image">
                                <img src={Resoures2} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">
                                <h5>Keeping yourself safe when buying NFTs on Toppy</h5>
                            </div>
                        </a>
                    </div>
                    <div className="item p-0">
                        <a href="#" >
                            <div className="image">
                                <img src={Resoures3} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">
                                <h5>Keeping yourself safe when buying NFTs on Toppy</h5>
                            </div>
                        </a>
                    </div>
                    <div className="item p-0">
                        <a href="#" >
                            <div className="image">
                                <img src={Resoures1} alt="" className="img-fluid" />
                            </div>
                            <div className="item-content">
                                <h5>Keeping yourself safe when buying NFTs on Toppy</h5>
                            </div>
                        </a>
                    </div>


                </Slider>
            </div>
        </section>
    )
}
export default Resources;